export default __webpack_public_path__ + "static/media/coldchain-check.641ed682.svg";